var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHammerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 121,
    viewBox: "0 0 131 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 2.86675C68.6667 4.33342 68 6.46676 68 7.80009C68 10.4668 92.6667 35.9334 96.2667 37.1334C100.133 38.3334 105.333 34.2001 105.333 30.0668C105.333 27.2668 102.267 23.4001 92.2667 13.4001C81.2 2.33342 78.5333 0.333421 74.9333 0.333421C72.1333 0.333421 70.2667 1.13342 69.3333 2.86675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1999 23.2668C48.9332 29.2668 43.1999 35.4002 42.3999 36.7335C41.1999 39.0002 42.7999 41.1335 53.4665 51.8002C60.3999 58.7335 66.3999 64.3335 67.0665 64.3335C68.9332 64.3335 92.2665 40.4668 91.7332 39.1335C91.4665 38.4668 85.7332 32.2002 78.9332 25.1335L66.5332 12.3335L55.1999 23.2668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 42.8668C28.6667 44.3334 28 46.4668 28 47.8001C28 50.4668 52.6667 75.9334 56.2667 77.1334C60.1333 78.3334 65.3333 74.2001 65.3333 70.0668C65.3333 67.2668 62.2667 63.4001 52.2667 53.4001C41.2 42.3334 38.5333 40.3334 34.9333 40.3334C32.1333 40.3334 30.2667 41.1334 29.3333 42.8668Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1332 54.5998L75.4666 61.7998L95.3332 81.6665C113.867 100.2 115.6 101.667 120.267 101.667C124 101.667 125.867 100.867 127.867 98.1998C133.333 91.2665 132.267 89.3998 110.4 67.3998C99.1999 56.1998 89.7332 46.9998 89.3332 47.1332C88.9332 47.2665 85.7332 50.5998 82.1332 54.5998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 95.9333C16.1334 97.2667 13.8667 99.4 13.6001 100.6C13.2001 102.867 15.4667 103 46.6667 103C78.6667 103 80.0001 102.867 78.8001 100.6C75.6001 94.7333 74.0001 94.3333 48.1334 93.9333C26.4001 93.6667 22.8001 93.8 18.6667 95.9333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3333 108.333C0.5333 109.933 -3.31584e-05 113.4 0.266634 116.067L0.666634 121H46H91.3333L91.7333 115.267C92.4 105.267 94.1333 105.667 45.8666 105.667C3.86663 105.667 2.66663 105.8 1.3333 108.333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerLogo);
export default __webpack_public_path__ + "static/media/HammerLogo.69e7130b2f46d9809757b23862ddc57b.svg";
export { ForwardRef as ReactComponent };